<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button
          type="primary"
          icon="plus"
          class="add-btn"
          @click="visible = true"
        >
          新增业务类型
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:action="{ tableRow }">
          <div>
            <template v-if="tableRow.freeze === 0">
              <a-button type="link" size="small" @click="handleEdit(tableRow)">
                编辑
              </a-button>
              <a-divider type="vertical" />
            </template>

            <template v-if="tableRow.freeze === 0">
              <a-popconfirm
                title="此操作将删除该业务类型, 是否继续?"
                @confirm="handleDeleteConfirm(tableRow)"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  class="icon-color"
                />
                <a-button type="link" size="small">
                  删除
                </a-button>
              </a-popconfirm>
              <a-divider type="vertical" />
            </template>

            <template v-if="tableRow.freeze === 0">
              <a-popconfirm
                title="此操作将冻结该业务类型, 是否继续?"
                @confirm="handleFreeze(tableRow)"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  class="icon-color"
                />
                <a-button type="link" size="small">
                  冻结
                </a-button>
              </a-popconfirm>
            </template>

            <template v-if="tableRow.freeze === 1">
              <a-popconfirm
                title="此操作将解冻该业务类型, 是否继续?"
                @confirm="handleThaw(tableRow)"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  class="icon-color"
                />
                <a-button type="link" size="small">
                  解冻
                </a-button>
              </a-popconfirm>
            </template>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
    >
      <a-form :form="modalForm">
        <a-form-item label="业务类型名称">
          <a-input
            :maxLength="100"
            allowClear
            v-decorator="$decorator('name', '业务类型名称')"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { add, remove, freeze, thaw } from 'views/setting/api'
import { getTableData } from './api'

export default {
  mixins: [mixin],
  data() {
    return {
      searchCardLoading: true,
      tableLoading: true,
      visible: false,
      modalForm: this.$form.createForm(this),
      modalTitle: '新增',
    }
  },
  components: {
    SearchView,
    TableView,
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    // 获取表格数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
      }

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
    // 提交和编辑
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = ''
          }

          try {
            const { message } = await add({
              ...values,
              id: this.id,
              type: 1,
            })
            this.visible = false

            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 弹窗关闭
    handleAfterClose() {
      this.id = ''
      this.modalTitle = '新增'
    },
    // 点击编辑
    handleEdit({ name, id }) {
      this.visible = true
      this.modalTitle = '编辑'
      setTimeout(() => {
        this.modalForm.setFieldsValue({
          name,
        })
        this.id = id
      }, 20)
    },
    // 删除
    handleDeleteConfirm({ id }) {
      remove(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    //冻结
    handleFreeze({ id }) {
      freeze(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    //解冻
    handleThaw({ id }) {
      thaw(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
  },
}
</script>
